import { Route, Switch } from 'react-router';

import { useBreadcrumbs } from '@/components/Breadcrumbs/useBreadcrumbs';
import { Routes } from '@/utils/routes';
import i18n from '@/utils/i18n';
import { PickingJobListView } from './PickingJobListView';
import { PickingJobDetail } from './PickingJobDetail';

export function PickingJobsPage() {
  useBreadcrumbs({
    id: 'picking-jobs',
    priority: 100,
    items: [
      {
        label: i18n.t('Picking:pageTitle'),
        href: Routes.pickingJobs(),
      },
    ],
  });

  return (
    <div className="tw:p-2 tw:pt-0 tw:pb-4 tw:max-w-[1400px]">
      <Switch>
        <Route
          path={Routes.pickingJobs()}
          exact
          component={PickingJobListView}
        />
        <Route
          path={Routes.pickingJobDetails(':pickingJobId')}
          component={PickingJobDetail}
        />
      </Switch>
    </div>
  );
}
